import { sysadminService, type EvidenciaSysadminDTO, type EvidenciasFilter } from '@/services/sysadmin.service';
import { useCallback, useEffect, useState } from 'react';

export function useEvidenciasSysadmin(filtros?: EvidenciasFilter) {
  const [data, setData] = useState<{ evidencias: EvidenciaSysadminDTO[] } | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchEvidencias = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await sysadminService.listarEvidencias(filtros);
      setData({ evidencias: res.evidencias });
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Error al cargar evidencias'));
    } finally {
      setIsLoading(false);
    }
  }, [filtros?.empresaId, filtros?.asesorId]);

  useEffect(() => {
    fetchEvidencias();
  }, [fetchEvidencias]);

  return { data, isLoading, error, refetch: fetchEvidencias };
}

export function useEliminarEvidenciaSysadmin() {
  const [isPending, setIsPending] = useState(false);

  const mutateAsync = async (evidenciaId: number) => {
    setIsPending(true);
    try {
      await sysadminService.eliminarEvidencia(evidenciaId);
    } finally {
      setIsPending(false);
    }
  };

  return { mutateAsync, isPending };
}
